<template>
  <div class="params-col">
    <!-- Hidden audio player -->
    <sync-audio-player
      :audio-src="soundSrc"
      :audio-duration="soundDuration"
      :start-time="startTime"
      :player-time="videoTime"
      :player-loading="videoLoading"
      :player-paused="videoPaused"
      :on="soundOn"
    />

    <!-- Load sound -->
    <div
      class="params-col__item params-row params-row_justify_center upload-row"
    >
      <div class="params-row__item">
        <el-button
          v-if="!muted"
          type="primary"
          title="Mute Origin Sound"
          class="mute-btn"
          @click="muteVideo"
        >
          <volume-high />
          <br />
          Mute Origin
        </el-button>
        <el-button
          v-else
          type="warning"
          title="Unmute Origin Sound"
          class="mute-btn"
          @click="unmuteVideo"
        >
          <volume-off />
          <br />
          Unmute Origin
        </el-button>
      </div>

      <div class="params-row__item">
        <audio-uploader
          v-if="!soundFile"
          :max-duration="maxDuration"
          :size-limit-m-b="sizeLimitMB"
          @upload="sound = $event"
          @fileUploaded="handleUploading"
          @resetUploading="handleResetting"
        />
      </div>
    </div>
    <div class="params-col__item params-row">
      <div v-if="sound" class="params-row__item params-row__grow-item">
        <span>Choose Sound Position</span>
        <fixed-time-slider v-model="soundPosition" :max="maxTime" />
      </div>
    </div>
    <div class="params-col__item params-row params-row_justify_center">
      <div class="params-row__item">
        <el-button
          v-if="soundFile"
          type="danger"
          title="Reset Audio Uploading"
          class="reset-btn"
          @click="handleResetting"
        >
          Reset Upload
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* Subcomponents */
import FixedTimeSlider from "@/components/sliders/FixedTimeSlider.vue";
import AudioUploader from "@/components/media/editing/AudioUploader.vue";
import SyncAudioPlayer from "@/components/media/audio/SyncAudioPlayer.vue";

/** Icons */
import VolumeHigh from "vue-material-design-icons/VolumeHigh.vue";
import VolumeOff from "vue-material-design-icons/VolumeOff.vue";

// @group Editing
// Sound mixing parameters
export default {
  name: "EditSoundPanel",
  components: {
    VolumeHigh,
    VolumeOff,
    FixedTimeSlider,
    AudioUploader,
    SyncAudioPlayer
  },
  props: {
    // Is video player paused (need to sync)
    videoPaused: {
      type: Boolean,
      required: true
    },
    // Is video player loading (need to sync)
    videoLoading: {
      type: Boolean,
      default: false
    },
    // Video player time (in seconds) (need to sync)
    videoTime: {
      type: Number,
      required: true
    },
    // Maximum duration of uploading sound (in seconds)
    maxDuration: {
      type: Number,
      required: true
    },
    // Is muted
    muted: {
      type: Boolean,
      default: false
    },
    // Is sound on
    soundOn: {
      type: Boolean,
      default: true
    },
    // Max uploaded file size in MB
    sizeLimitMB: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      soundPosition: [0, 1],
      soundFile: null,
      sound: null
    };
  },
  computed: {
    // @vuese
    // Sound source or null
    soundSrc() {
      return this.sound == null ? null : this.sound.src;
    },
    // @vuese
    // Sound duration or null
    soundDuration() {
      return this.sound == null ? null : this.sound.duration;
    },
    // @vuese
    // Sound position start in seconds
    startTime: {
      cache: false,
      get() {
        return this.soundPosition[0];
      }
    },
    // @vuese
    // Rounded maximum duration (need to avoid problrm with slider interval)
    maxTime() {
      return Math.floor(this.maxDuration);
    }
  },
  watch: {
    // Set sound position when sound has uploaded
    sound(sound) {
      if (sound != null) {
        this.soundPosition = [0, sound.duration];
      }
    },
    soundFile() {
      // Sound file updated
      this.$emit("fileUploaded", this.soundFile);
    },
    soundPosition() {
      // Sound position changed
      this.$emit("soundMoved", this.soundPosition[0]);
    }
  },
  methods: {
    // @vuese
    // Signal to mute video
    muteVideo() {
      // User clicked "mute"
      this.$emit("muteVideo");
    },
    // @vuese
    // Signal to unmute video
    unmuteVideo() {
      // User clicked "unmute"
      this.$emit("unmuteVideo");
    },
    // @vuese
    // Initialize uploaded sound file
    handleUploading(file) {
      this.soundFile = file;
      // Sound uploaded
      this.$emit("enableSound");
    },
    // @vuese
    // Remove uploaded sound
    handleResetting() {
      this.soundFile = null;
      this.sound = null;
      // Sound removed
      this.$emit("disableSound");
    }
  }
};
</script>

<style scoped>
.el-row:not(:last-child) {
  margin-bottom: 2em;
}
.mute-btn {
  color: black;
  height: 71px;
  width: 8.5em;
}
</style>
